import { useEffect } from 'react';

const GLYPHS = '!<>-_/[]{}=+*^?#01';
const DURATION = 800;

// Writes into the text node React already owns (nodeValue, not textContent),
// so a later language switch still updates it cleanly.
function scramble(el) {
  const node = el.firstChild;
  if (!node || node.nodeType !== 3 || el.childNodes.length !== 1) return;
  const finalText = node.nodeValue;
  const start = performance.now();
  const tick = (now) => {
    const p = Math.min((now - start) / DURATION, 1);
    const settled = Math.floor(p * finalText.length);
    let out = '';
    for (let i = 0; i < finalText.length; i += 1) {
      const ch = finalText[i];
      out += i < settled || ch === ' ' ? ch : GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
    }
    node.nodeValue = p < 1 ? out : finalText;
    if (p < 1) requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
}

/** Headlines marked `data-scramble` resolve left to right the first time they enter view. */
export default function useScramble(deps = []) {
  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return undefined;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    let io;
    const raf = requestAnimationFrame(() => {
      const els = document.querySelectorAll('[data-scramble]:not([data-scrambled])');
      io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            e.target.setAttribute('data-scrambled', '');
            io.unobserve(e.target);
            scramble(e.target);
          });
        },
        { threshold: 0.6 }
      );
      els.forEach((el) => io.observe(el));
    });
    return () => {
      cancelAnimationFrame(raf);
      if (io) io.disconnect();
    };
  }, deps); // eslint-disable-line
}
